import * as stylex from '@stylexjs/stylex';
import { useNavigate } from 'react-router-dom';
import seeqLogoWhite2026 from 'resources/img/seeq_logo_white_2026_sm_padding.png';
import { SeeqLogo2026 } from '@/core/SeeqLogoWhite.atom';
import { WrapperWithLink } from '@/core/WrapperWithLink.atom';
import { headerStyles as styles } from '@/header/header.styles';
import { getWorkbooksLink } from '@/main/routing.utilities';
import { resetWorkbookType, setWorkbookDisplayMode } from '@/workbook/workbook.actions';
import { WORKBOOK_DISPLAY } from '@/workbook/workbook.constants';

interface HeaderLogoProps {
  disableLink?: boolean;
}

export const HeaderLogo = ({ disableLink = false }: HeaderLogoProps) => {
  const navigate = useNavigate();

  const gotoHomeScreen = () => {
    resetWorkbookType();
    navigate(getWorkbooksLink());
    setWorkbookDisplayMode(WORKBOOK_DISPLAY.EDIT);
  };

  return (
    <div {...stylex.props(styles.logo)} data-testid="headerLogo">
      <WrapperWithLink link={getWorkbooksLink()}>
        <div {...stylex.props(styles.logoLink, disableLink && styles.disabledLogoLink)}>
          <SeeqLogo2026
            className={stylex.props(styles.logoImage).className}
            onClick={disableLink ? undefined : gotoHomeScreen}
            src={seeqLogoWhite2026}
            width={80}
          />
        </div>
      </WrapperWithLink>
    </div>
  );
};
